"use client";

import React from "react";
import { BookText, ChevronRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { cn } from "@/lib/utils";

interface BookCardProps {
  title: string;
  author?: string;
  coverImage?: string; // Mantido por compatibilidade, mas ignorado visualmente
  progress: number;
  onClick: () => void;
}

export function BookCard({ title, author, progress, onClick }: BookCardProps) {
  return (
    <Card 
      onClick={onClick}
      className={cn(
        "group cursor-pointer h-full flex flex-col justify-between p-5 transition-all duration-300",
        "bg-card border-border/50 shadow-sm hover:shadow-md hover:border-primary/40",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/60"
      )}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="flex items-start gap-4 mb-6">
        <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-primary/10 text-primary shrink-0 transition-colors group-hover:bg-primary/15">
          <BookText className="w-6 h-6" />
        </div>
        
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-base sm:text-lg text-foreground leading-tight line-clamp-2 mb-1 group-hover:text-primary transition-colors">
            {title}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-1">
            {author ? `por ${author}` : "Sem autor"}
          </p>
        </div>
      </div>

      <div className="mt-auto space-y-3">
        <div className="flex items-center justify-between text-sm">
          <span className="font-medium text-muted-foreground">Progresso</span>
          <div className="flex items-center gap-2">
            <span className="font-semibold text-foreground">{progress}%</span>
            <ChevronRight className="w-4 h-4 text-muted-foreground group-hover:text-primary transition-transform group-hover:translate-x-0.5" />
          </div>
        </div>
        <Progress value={progress} className="h-2" />
      </div>
    </Card>
  );
}